import { a as m } from "./chunk-BaseElement-CJM6sCUz.js";
import { c as f } from "./chunk-aria-live-region-context-BoiIzOeU.js";
import { c as h } from "./chunk-consume-s_2mmxxA.js";
import { E as n, x as v } from "./chunk-lit-element-D3OkYgeM.js";
import { t as g } from "./chunk-custom-element-CN0MC8o7.js";
var c = Object.defineProperty, u = Object.getOwnPropertyDescriptor, p = (i, r, s, t) => {
  for (var e = t > 1 ? void 0 : t ? u(r, s) : r, o = i.length - 1, a; o >= 0; o--)
    (a = i[o]) && (e = (t ? a(r, s, e) : a(e)) || e);
  return t && e && c(r, s, e), e;
};
let l = class extends m {
  get politeness() {
    var i;
    return ((i = this.ariaLiveRegion) == null ? void 0 : i.politeness) || "assertive";
  }
  render() {
    return this.ariaLiveRegion ? v`
      <div class="sr-only" aria-live=${this.politeness} role="status">
        ${this.ariaLiveRegion.title ? v`<h2>${this.ariaLiveRegion.title}</h2>` : n}
        ${this.ariaLiveRegion.message ?? n}
      </div>
    ` : v`${n}`;
  }
};
p([
  h({ context: f, subscribe: !0 })
], l.prototype, "ariaLiveRegion", 2);
l = p([
  g("aria-live-region")
], l);
export {
  l as LiveRegion
};
